import { render, staticRenderFns } from "./chgCardQuery.vue?vue&type=template&id=1db342c4&scoped=true&"
import script from "./chgCardQuery.vue?vue&type=script&lang=js&"
export * from "./chgCardQuery.vue?vue&type=script&lang=js&"
import style0 from "./chgCardQuery.vue?vue&type=style&index=0&id=1db342c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db342c4",
  null
  
)

export default component.exports